import _get from 'lodash/get';
import { userService } from '@bedrock/fido-sdk';
import { appPlatform } from '@bedrock-rdk/utils';
import { sendEvent } from '../analytics/analytics.utils';

export const getUpdatedAnalytics = isBookmarked => ({
  googleAnalytics: {
    eventAction: isBookmarked ? 'bookmark' : 'unbookmark',
  },
  krxd: {
    appPlatform,
    key: isBookmarked ? 'bookmarkAdd' : 'bookmarkRemove',
  },
  ssaTealiumHttp: {
    key: isBookmarked ? 'bookmark' : 'unbookmark',
  },
});

export const getBookmarkActionAnalytics = (item, bookmarkState) =>
  item.analytics
    ? Object.keys(item.analytics).reduce((result, key) => {
        result[key] = {
          ...item.analytics[key],
          ..._get(getUpdatedAnalytics(bookmarkState), key, {}),
        };

        return result;
      }, {})
    : {};

/**
 * Adds a bookmark for a program specified in the bookmark object
 * @param {Object} bookmark action item received from Layout API
 * @param {string} userId
 */
export const addBookmark = async (bookmark, userId) => {
  try {
    await userService.addBookmark({
      entityId: bookmark.id,
      entityType: bookmark.type,
      uid: userId,
    });
    sendEvent({ key: 'bookmark' });
  } catch (error) {
    // TODO: error handling
  }
};

/**
 * Removes a bookmark for a program specified in the bookmark object
 * @param {Object} bookmark action item received from Layout API
 * @param {string} userId
 */
export const removeBookmark = async (bookmark, userId) => {
  try {
    await userService.removeBookmark({
      entityId: bookmark.id,
      entityType: bookmark.type,
      uid: userId,
    });
    sendEvent({ key: 'unbookmark' });
  } catch (error) {
    // TODO: error handling
  }
};
